import { ComponentProps } from 'preact/compat';

import withDefaults from '@/components/withDefaults';
import { cn } from '@/lib/utils';

export const ProductFeaturesList = withDefaults('ul', {
  className: 'preflight preflight-ul flex flex-col gap-3',
});

type ProductFeaturesListItemProps = ComponentProps<'li'>;

export const ProductFeaturesListItem = ({ className, children, ...props }: ProductFeaturesListItemProps) => {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <li className={cn('flex text-base text-stone-900', className)} {...props}>
      <div className="mr-3 shrink-0 pt-0.5">
        <div className="flex size-5 items-center justify-center rounded-full bg-primary-yellow text-primary-green">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="preflight preflight-svg size-5"
          >
            <path
              d="M15.7722 6.83313L10.068 14.574C9.93197 14.7545 9.72912 14.8727 9.50503 14.9022C9.28094 14.9316 9.05441 14.8698 8.87634 14.7306L4.80301 11.474C4.44356 11.1863 4.38536 10.6617 4.67301 10.3023C4.96066 9.94285 5.48523 9.88465 5.84468 10.1723L9.24134 12.8898L14.4305 5.8473C14.6007 5.59195 14.8974 5.45078 15.2029 5.47983C15.5083 5.50887 15.7731 5.70344 15.8921 5.98627C16.0111 6.26911 15.965 6.59445 15.7722 6.83313Z"
              fill="currentColor"
            />
          </svg>
        </div>
      </div>
      <span className="font-medium">{children}</span>
    </li>
  );
};
